import './hoverTooltip.scss';
import React from 'react';

interface ITooltipProps {
    title: string;
    children: JSX.Element;
    placement?: string;
    hideArrow?: boolean;
}
export const HoverTooltip = (props: ITooltipProps) => {
    const { children, title, hideArrow, placement = 'bottom' } = props;
    const renderTip = () => {
        if (!title) {
            return null;
        }

        return (
            <div className={`umu-design-comp-tooltip umu-design-comp-tooltip-placement-${placement}`}>
                <div className="umu-design-comp-tooltip-content">
                    {!hideArrow && (
                        <div className="umu-design-comp-tooltip-arrow">
                            <span className="umu-design-comp-tooltip-arrow-content"></span>
                        </div>
                    )}
                    <div className="umu-design-comp-tooltip-inner" role="tooltip">
                        {title}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="hover-tooltip-wrap">
            {renderTip()}
            {children}
        </div>
    );
};
